import { OnboardingPage } from './OnboardingPage';

/**
 * /onboarding entry point.
 *
 * The onboarding flow is now a single-page form (OnboardingPage). The old
 * 4-step wizard at OnboardingWizardPage is kept in the tree for reference
 * but is no longer routed — its API endpoints (GET/PATCH /onboarding,
 * skip-branding) still exist on the backend if we ever want incremental
 * post-creation edits.
 *
 * On the workspace subdomain, OnboardingPage's `useMe` effect detects an
 * existing workspace and bounces the user to its root; on apex it renders
 * the create form.
 *
 * PLATFORM ADMINS NEVER ONBOARD. A console session holds no workspace by
 * design, so every "this user has no workspace" signal in the shell —
 * WorkspaceShell's next_step, RequireUnauthed's null slug, LoginPage's and
 * VerifyOtpPage's post-login routing.
 *
 * There is deliberately no platform-admin redirect here any more. The console
 * is a SEPARATE application (clarix-admin-frontend against clarix-admin-backend)
 * on its own origin with its own sign-in; a tenant session cannot be a console
 * session, so nothing reaching this page can belong there. `/admin` is not a
 * route of this shell — don't re-add a <Navigate> to it.
 */
export function OnboardingEntry() {
  return <OnboardingPage />;
}
